import {Flex, Skeleton, Typography} from 'antd';
import {getGMMemmberRewardsInfo} from 'Redux/Slices/gmMemberRewards';
import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {useSnackBar} from 'Hooks';
import SnackBar from 'Components/SnackBar';

const MemberAccountInfo = (props) => {
  const {selectedMember} = useSelector((state: any) => state?.selectedMember);
  const [memberAccountInfo, setmemberAccountInfo] = useState<any>();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [isSnackBarOpen, closeSnackBar] = useSnackBar(error);

  const dispatch = useDispatch();

  useEffect(() => {
    getMemberAccountInfo();
  }, [props.updateAccount]);

  const getMemberAccountInfo = async () => {
    try {
      const data1 = {externalRefId: selectedMember?.focusedMemberDetails?.externalRefId};
      let response = await dispatch(getGMMemmberRewardsInfo(data1)).unwrap();
      const {data, loading, error} = response;
      _handleResponse(data, loading, error);
    } catch (error: any) {
      console.error(error);
      return error;
    }
  };

  const _handleResponse = (data, loading, error) => {
    setLoading(loading);
    error && setError(error.message);
    if (data) {
      setmemberAccountInfo(data?.memberAccountInfo);
    }
  };

  const numberWithCommas = (x: number): string => {
    if (x) {
      return x.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ',');
    }
    return '0';
  };
  return (
    <>
      {loading ? (
        <Skeleton active avatar paragraph={{rows: 2}} />
      ) : error ? (
        <SnackBar
          errorMessage={error}
          closeSnackBar={closeSnackBar}
          isSnackBarOpen={isSnackBarOpen}
        />
      ) : (
        <Flex justify="end" align="center">
          <Typography.Text>
            <div>{'AVAILABLE POINTS'}</div>
            <div style={{display: 'flex', justifyContent: 'flex-end', fontWeight: 'bold'}}>
              {numberWithCommas(memberAccountInfo?.redeemablePoints)}
            </div>
          </Typography.Text>
          <Typography.Text style={{marginLeft: 40}}>
            <div>{'AVAILABLE CASH BALANCE'}</div>
            <div style={{display: 'flex', justifyContent: 'flex-end', fontWeight: 'bold'}}>
              ${numberWithCommas(memberAccountInfo?.redeemableDollars)}/$
              {numberWithCommas(memberAccountInfo?.capDollars)}
            </div>
          </Typography.Text>
        </Flex>
      )}
    </>
  );
};

export default MemberAccountInfo;
